import * as React from 'react';
import * as style from './OffersBlock.css';
import { Layout } from '../Layout';

export interface IPriceProps {
  title: React.ReactNode;
  offers: React.ReactNode;
  priceRelevance: React.ReactNode;
}

export function OffersBlock({ title, offers, priceRelevance }: IPriceProps) {
  return (
    <Layout id="layouts">
      {title}
      <div className={style['relevance']}>{priceRelevance}</div>
      <div className={style['container']}>
        <div className={style['offers']}>{offers}</div>
      </div>
    </Layout>
  );
}
